import Lottie from 'react-lottie';
import animationData from 'src/modules/ambient_solo/components/CurrentEncounter/ambient ai.json';

const sizeMap = {
  md: { width: 100, height: 100 },
};

export type AmbientAnimationProps = {
  size?: keyof typeof sizeMap;
  isPaused?: boolean;
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'onClick'>;

export default function AmbientAnimation({
  size = 'md',
  isPaused = false,
  onClick,
}: AmbientAnimationProps) {
  const defaultOptions = {
    loop: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const { width, height } = sizeMap[size];

  return (
    <div onClick={onClick}>
      <Lottie
        isStopped={isPaused}
        isPaused={isPaused}
        options={defaultOptions}
        height={height}
        width={width}
        style={{ pointerEvents: 'none' }}
      />
    </div>
  );
}
